module.exports = __webpack_public_path__ + "img/fluid-wagon-3.7e4c5780.png";